import { render } from "./management.cattle.io.roletemplate.vue?vue&type=template&id=dd2098d6"
import script from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__